"use strict";
exports.__esModule = true;
var angular = require("angular");
exports.Component = function (options) {
    return function (controller) { return angular.extend(options, { controller: controller }); };
};
function getDate(timestamp) {
    if (timestamp === void 0) { timestamp = null; }
    if (timestamp === '-') {
        return timestamp;
    }
    var date = timestamp ? new Date(timestamp) : new Date();
    var dateInString = date.toString();
    var splitTimestamp = dateInString.split(' ');
    var timeWithoutSec = splitTimestamp[4].substring(0, splitTimestamp[4].length - 3);
    var timeZone = splitTimestamp.slice(6, splitTimestamp.length);
    return '' + splitTimestamp[1] + ' ' + splitTimestamp[2] + ' ' + splitTimestamp[3] + ' ' + timeWithoutSec + ' ' + timeZone;
}
exports.getDate = getDate;
function loadSettings(portfolioName, settingsFromWorkbench) {
    var settings = settingsFromWorkbench || {};
    var sessionSettingString = localStorage.getItem('PortfolioConfig');
    if (sessionSettingString) {
        var sessionSettings = JSON.parse(sessionSettingString)[portfolioName];
        if (sessionSettings && sessionSettings.table) {
            settings = sessionSettings.table;
            settings.timestampMode = sessionSettings.timestamp ?
                sessionSettings.timestamp.timestampMode : settingsFromWorkbench.timestampMode;
        }
    }
    return {
        userDefaultDecimals: settings.decimals.toString().toLowerCase() === 'default',
        decimals: settings.decimals.toString().toLowerCase() === 'default' ? settings.defaultPrecision : settings.decimals,
        timestampMode: settings.timestampMode || 'lastRecalc'
    };
}
exports.loadSettings = loadSettings;
//# sourceMappingURL=basic-table.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/basic-component/basic-table.component.js